import { oz } from '@weft/utils';
import { ApiDateSchema, ObjectIdSchema } from '../../../primitives/';
import { NetSuiteInvoiceItemSchema } from './net-suite-invoice-item-schema';

export const NetSuiteInvoiceSchema = oz.object({
  startDate: ApiDateSchema,
  endDate: ApiDateSchema,
  tranDate: ApiDateSchema,
  memo: oz.string(),
  externalId: ObjectIdSchema,
  entity: oz.object({
    id: oz.string(),
  }),
  account: oz.object({
    id: oz.string(),
  }).optional(),
  item: oz.object({
    items: oz.array(NetSuiteInvoiceItemSchema),
  }),
  discountItem: oz.object({
    id: oz.string(),
  }).optional(),
  discountRate: oz.number().optional(),
});

export type NetSuiteInvoice = oz.infer<typeof NetSuiteInvoiceSchema>;